<template>
  <div class="wrap">
    <div class="item border-bottom" v-for="(item,index) in detail.videoList" :key="item.video_id">
      <div class="list-num">
        <span>{{index+1}}</span>
      </div>
      <div class="name-wrap">
        <p class="name" :class="{active:canPlay(item)}" @click="play(item)">{{item.title}}</p>
        <p class="time"><i class="iconfont icon-shijian"></i>{{item.duration}}分钟</p>
      </div>
      <div class="try-wrap" @click="play(item)">
        <span class="try" v-if="canTry(item)">可试看</span>
        <span class="play-icon" :class="{active:canPlay(item)}" v-else><i class="iconfont icon-bofang2"></i></span>
      </div>
    </div>
    <div class="item border-bottom" v-for="item in detail.videoList" :key="item.video_id" v-if="false">
      <div class="icon">
        <i class="iconfont icon-bofang1" v-if="detail.is_buy||item.isallow"></i>
        <i class="iconfont icon-suo" v-else></i>
      </div>
      <div class="name-wrap">
        <router-link tag="p" class="name" v-if="(!detail.is_buy)&&item.isallow" :to="'/play/'+item.course_id+'/'+item.video_id">{{item.title}}</router-link>
        <router-link tag="p" class="name" v-else-if="detail.is_buy" :to="'/play/'+item.course_id+'/'+item.video_id">{{item.title}}</router-link>
        <p class="name" v-else @click="$toast('请您先购买再观看')">{{item.title}}</p>
        <p class="time">{{item.createtime}}</p>
      </div>
      <div class="try-wrap">
        <router-link class="try" tag="span" v-if="(!detail.is_buy)&&item.isallow" :to="'/play/'+item.course_id+'/'+item.video_id">试听</router-link>
        <router-link class="play" tag="span" v-else-if="detail.is_buy" :to="'/play/'+item.course_id+'/'+item.video_id">播放</router-link>
        <span class="play" v-else @click="$toast('请您先购买再观看')">播放</span>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: ['detail'],
  activated() {
    this.$emit('refreshScroll')
    this.$emit('setNavTitle', '内容列表')
  },
  methods: {
    play(item) {
      // 跳转到播放页面判断
      if (this.canPlay(item)) {
        // 买了或者允许试看
        this.$router.push('/play/' + item.course_id + '/' + item.video_id)
      } else {
        this.$toast('请您先购买再观看')
      }
    },
    canPlay(item) {
      return !!(this.detail.is_buy || item.isallow)
    },
    canTry(item) {
      // 能否试看，如果买了 就认为不是试看了!!
      return !!(!this.detail.is_buy && item.isallow)
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  /*
  .wrap
    padding-bottom size(98)
  .title
    line-height size(92)
    padding 0 size(30)
    font-weight 700
    color #333
    font-size size(34)
  .item
    display table
    width 100%
    padding 0 size(30)
    height size(108)
    table-layout fixed
    overflow hidden
    >div
      display table-cell
      vertical-align middle
    .icon
      //width size(62)
      width  percentage(62/690)
      .iconfont
        font-size 18px
        color #666
    .name-wrap
      width percentage((690 - 62- 120)/690)
    .name
      font-size size(30)
      color #333
      font-weight 700
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      padding size(6) 0
    .time
      font-size size(26)
      color #999
      margin-top size(9)
    .try-wrap
      //width size(120)
      width  percentage(120/690)
      text-align right
      >span
        display inline-block
        font-size size(26)
        padding size(10) size(20)
        border-radius 5px
      .try
        color #ffffff
        background $color-theme
      .play
        border: 1px solid #999
        color #999
  */
  .wrap
    padding-bottom size(100)
    padding-left size(30)
  .item
    display flex
    width 100%
    padding size(22) 0
    .list-num
      width size(60)
      text-align center
      font-weight 800
      color #bdbdbd
      line-height size(44)
      vertical-align top
    .name-wrap
      flex 1
    .name
      font-size size(32)
      font-weight 800
      line-height size(44)
      overflow hidden
      text-overflow ellipsis
      display -webkit-box
      -webkit-line-clamp 2
      -webkit-box-orient vertical
      word-wrap break-word
      word-break break-all
      color #999
      &.active
        color #333
    .time
      font-size size(26)
      color #a2a2a2
      line-height size(48)
      .iconfont
        font-size 13px
        margin-right size(10)
    .try-wrap
      min-width size(80)
      padding 0 size(30)
      box-sizing content-box
      white-space nowrap
      position relative
      >span
        position absolute
        top 50%
        transform translateY(-50%)
      .try
        color $color-theme
        font-size size(26)
      .play-icon
        color #c3c3c3
        &.active
          color $color-theme
        .iconfont
          font-size 20px
</style>



// WEBPACK FOOTER //
// src/components/systematic/systematic-play-list.vue